<template>
<div>
  <van-row style="background-color: gainsboro">
    <van-col :span="22" style="margin: 2%; margin-top: 2%;">
      <div style="font-weight: bolder">{{ customerNotic.noticeTitle }}</div>
      <span style="font-size: xx-small">{{customerNotic.createTime}}</span>
    </van-col>
  </van-row>
  <van-row>
    <van-col :span="22" style="margin: 2%">
      <div v-html="customerNotic.noticeContent"></div>
    </van-col>
  </van-row>
</div>
</template>

<script>
export default {
name: "VipMemberContent",
  data(){
  return {
    customerNotic:{

    }
  }
  },
  mounted() {
    this.$emit("titleChange", "试客公告");
    this.customerNotic = this.$route.query.customerNotic;
  },
  methods: {

  }
}
</script>

<style scoped>
.header{
  line-height: 33px;
  border-bottom: 1px dashed dodgerblue;
}
</style>
